var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesforce = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99913 4.82087C10.7687 4.02 11.8383 3.52174 13.0226 3.52174C14.5983 3.52174 15.9704 4.40087 16.7009 5.70261C17.3374 5.41826 18.0391 5.25913 18.78 5.25913C21.6209 5.25913 23.9217 7.58087 23.9217 10.4452C23.9217 13.3096 21.6209 15.6313 18.78 15.6313C18.433 15.6313 18.0939 15.5974 17.7678 15.5296C17.1235 16.6774 15.8948 17.4548 14.4861 17.4548C13.8965 17.4548 13.3383 17.3191 12.8426 17.0765C12.1904 18.613 10.667 19.6904 8.89565 19.6904C7.12435 19.6904 5.47565 18.5217 4.87043 16.8835C4.60696 16.9383 4.33304 16.9696 4.0513 16.9696C1.85217 16.9696 0.0704346 15.1696 0.0704346 12.947C0.0704346 11.4574 0.871304 10.1583 2.06087 9.46174C1.81565 8.89826 1.68 8.27478 1.68 7.62261C1.68261 5.0713 3.75913 3 6.31565 3C7.81826 3 9.15391 3.71478 9.99913 4.82087Z",
    fill: "#0D9DDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesforce);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/salesforce.73c1183bc7f4249ff9a9c7c888238bd6.svg";